import React from "react";
import {
	Container,
	Flex,
	Heading,
	ListItem,
	OrderedList,
	Text,
} from "@chakra-ui/react";
import MemberHeroSection from "@/components/membership/MemberHeroSection";
import CustomButton from "@/components/common/CustomButton";

const TeamOfManagerAif = () => {
	const sampleDoc =
		"https://static.levocdn.com/WGLBUT82/SampleTemplateofUndertakingtoObtainNISMAIFCertification-pKkglu1Ik7yx.docx";

	return (
		<div>
			<Flex direction="column" rowGap="20px">
				<MemberHeroSection
					title={
						<Heading
							as="h1"
							variant="headingText"
							color="text.headingWhite"
							fontSize={{ xs: "36px", sm: "60px", md: "74px" }}
							textAlign={{ xs: "left", sm: "left" }}
						>
							Certification requirement for key investment team of manager of
							AIF
						</Heading>
					}
					type="about-us"
				/>
				<Container
					maxW="800px"
					pt={{ xs: "50px", md: "50px" }}
					pb={{ xs: "50px", md: "50px" }}
					as="section"
					id="info"
					scrollMarginTop="140px"
				>
					<Text
						pb="16px"
						variant="heroDesc"
						color="text.mediumBlackAlpha"
						textAlign="justify"
					>
						In accordance with SEBI&apos;s regulatory requirements, IVCA
						provides guidance on the certification requirement for key
						investment team members of Alternative Investment Funds (AIFs).
					</Text>
					<Text variant="infoText">Overview</Text>
					<Text
						pb="16px"
						variant="heroDesc"
						color="text.mediumBlackAlpha"
						textAlign="justify"
					>
						On May 13, 2024, SEBI issued Circular No.:
						SEBI/HO/AFD-1/AFD-1-PoD/P/CIR/2024/42 titled “Certification
						requirement for key investment team of manager of AIF.” According to
						this circular, at least one key personnel of the key investment team
						must obtain the necessary certification from NISM before the launch
						of the AIF. This certification is now an eligibility criterion for
						obtaining AIF registration or launching a scheme.
					</Text>
					<Text variant="infoText">IVCA&apos;s Representation to SEBI</Text>
					<Text
						pb="16px"
						variant="heroDesc"
						color="text.mediumBlackAlpha"
						textAlign="justify"
					>
						In response to the SEBI circular, IVCA made a representation
						requesting that AIFs be allowed to file their documents with SEBI
						along with an undertaking. This undertaking must state that at least
						one key personnel of the key investment team will obtain the
						necessary certification from NISM before the launch of the AIF. SEBI
						has accepted this request and has asked industry associations to
						inform their members accordingly.
					</Text>
					<Text variant="infoText">Action Required</Text>
					<Text
						pb="16px"
						variant="heroDesc"
						color="text.mediumBlackAlpha"
						textAlign="justify"
					>
						All AIF members are required to adhere to the following steps:
						<OrderedList pl="1rem" pt="0.5rem">
							<ListItem>
								Review SEBI Circular No.: SEBI/HO/AFD-1/AFD-1-PoD/P/CIR/2024/42{" "}
								<Text
									as="span"
									textDecoration="underline"
									cursor="pointer"
									onClick={() => {
										window.open(
											"https://www.sebi.gov.in/legal/circulars/may-2024/certification-requirement-for-key-investment-team-of-manager-of-aif_83328.html",
											"_blank",
										);
									}}
								>
									here
								</Text>
								.
							</ListItem>
							<ListItem>
								Prepare the undertaking using the provided template.
							</ListItem>
							<ListItem>
								Ensure that at least one key personnel of the key investment
								team obtains the NISM AIF Certification before the launch of the
								AIF.
							</ListItem>
						</OrderedList>
					</Text>
					<Text variant="infoText">Undertaking Template</Text>
					<Text
						pb="16px"
						variant="heroDesc"
						color="text.mediumBlackAlpha"
						textAlign="justify"
					>
						A sample copy of the undertaking is provided below for your
						reference. You may adopt a similar template based on discussions
						with your advisors. The content highlighted in yellow may be amended
						depending on whether the Manager or the Sponsor is signing the
						undertaking and whether the application is for a new AIF approval or
						the launch of a scheme.
					</Text>
					<Text pb="16px" fontWeight="bold">
						Deadline: June 30, 2024
					</Text>
					<Text
						pb="16px"
						variant="heroDesc"
						color="text.mediumBlackAlpha"
						textAlign="justify"
					>
						For any questions or further information, please contact us at
						info@ivca.in.
					</Text>
					<Flex gap="4px">
						<CustomButton
							text="Download Sample template to Obtain NISM AIF Certification"
							colorScheme="primary"
							icon
							btnStyle={{ width: "fit-content", whiteSpace: "pre-wrap" }}
							handleButtonClick={() => window.open(sampleDoc, "_blank")}
						/>
					</Flex>
				</Container>
			</Flex>
		</div>
	);
};

export default TeamOfManagerAif;
